import { Form } from "semantic-ui-react";
import { FieldLabelWithButton } from "../../FieldLabelWithButton";
import classNames from "classnames";
import { useId } from "react-aria";

export interface SharedAddressFieldProps {
  value: {
    attn?: string;
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    countryId?: string;
  } | null;
  handleChange: (change: { [key: string]: string }) => void;
  transform: {
    input: (value: any) => any;
    output: (value: any) => any;
  };
  required?: boolean;
  label?: string;
  labelClassName?: string;
  subLabel?: string;
  disabled?: boolean;
  error?: string;
  isMobileLayout?: boolean;
}

interface AddressFieldProps extends SharedAddressFieldProps {
  showAttnField?: boolean;
  showAttnFieldToggle?: boolean;
  handleChange: (value: { attn?: string; address?: string }) => void;
  autofill?: boolean;
  autofillRef?: React.MutableRefObject<HTMLInputElement | null>;
  setShowAttnField?: (show: boolean) => void;
}

export function AddressFormField({
  disabled,
  error,
  labelClassName,
  transform,
  required,
  handleChange,
  label = "Address",
  subLabel,
  showAttnField,
  showAttnFieldToggle,
  value,
  autofill,
  autofillRef,
  setShowAttnField,
}: AddressFieldProps) {
  const id = useId();
  return (
    <Form.Field className='tw-w-auto' disabled={disabled} error={!!error}>
      <FieldLabelWithButton
        buttonText='Add Attn'
        label={label}
        htmlFor={id}
        required={required}
        showButton={!showAttnField && showAttnFieldToggle && !value?.attn}
        onClick={(e) => {
          e.preventDefault();
          setShowAttnField?.(true);
        }}
        className={labelClassName}
      />
      {subLabel && (
        <div
          className={classNames("sub-label", {
            "tw-text-[#b2b2b2]": disabled,
          })}
        >
          {subLabel}
        </div>
      )}
      <div className='ui input'>
        <input
          id={id}
          type='text'
          ref={autofill ? autofillRef : undefined}
          disabled={disabled}
          value={transform.input(value)?.address ?? ""}
          autoComplete='address-line1'
          onChange={(e) => handleChange?.({ address: e.target.value })}
          placeholder=''
        />
      </div>
    </Form.Field>
  );
}
